<ng-container *msShowInEpcot="{ showInEpcot: false, module: module }">
    <span class="theme-locked-i" *ngIf="offline; else optionGroupView" [style.color]="textColor"></span>
</ng-container>
<ng-container *msShowInEpcot="{ showInEpcot: true, module: module }">
    <span class="theme-lock" *ngIf="offline; else optionGroupView" [style.color]="textColor"></span>
</ng-container>
<ng-template #optionGroupView>
    <div class="six-pack-option option-group-attribute" *ngIf="optionGroup.balanced && optionGroup.categoryAttribute">
        <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="optionGroup.categoryAttribute" />
    </div>
    <ms-six-pack-option
        *ngFor="let option of options; trackBy: trackOption"
        [decorateAttribute]="decorateAttribute"
        [option]="option"
        [optionGroup]="optionGroup"
        [event]="event"
        [isHighlighted]="shouldHighlight(option)"
        [trackingPosition]="trackingPosition"
        [isAutomatedMarquee]="isAutomatedMarquee"
        [msAutomation]="getAutomationAttributes(option, optionGroup)" />
</ng-template>
